import { render, staticRenderFns } from "./tabMutasiJabatan.vue?vue&type=template&id=d189ec36"
import script from "./tabMutasiJabatan.vue?vue&type=script&lang=js"
export * from "./tabMutasiJabatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports